import { Injectable } from '@angular/core';
import { SystemDetails } from '@twaice-fe/shared/models';
import { ConnectionStatus } from './navigation-menu.types';

@Injectable()
export class NavigationMenuService {
  private readonly lastSeenWarningHours = 12;

  // isSystemOnboarded is the backend's raw2clean flag, so without it clean data can never exist.
  getConnectionStatus(lastSeenTimestamp: Date | null, selectedStorage: SystemDetails | undefined, now: Date): ConnectionStatus {
    if (selectedStorage && !selectedStorage.isSystemOnboarded) return 'not-onboarded';

    const isStale =
      !lastSeenTimestamp || lastSeenTimestamp.getTime() + this.lastSeenWarningHours * 60 * 60 * 1000 < now.getTime();

    return isStale ? 'stale' : 'live';
  }
}
